import { useTranslation } from "react-i18next";
import { BillingPeriod, BillingPeriodMonths, BillingPeriodText, BillingPeriodUnit } from "../../constants/billing";
import { capitalize } from "../../utils/string";
import { TimeAgo } from "../TimeAgo/TimeAgo";
import { formatMoney } from "../../utils/number";
import { LOCALES } from "../Datetime/Datetime";

export function CurrentPrice({ currentPrices, period, ...props }) {
   const { t, i18n } = useTranslation();

   if (!currentPrices || !period)
      return;

   const priceMonth = currentPrices[BillingPeriod.MONTHLY];
   const price = currentPrices?.[period];
   const periodMonths = BillingPeriodMonths[period];

   return (
      <div>
         {price ? (
            <div className="inline-flex flex-row gap-10! items-center w-full px-4! py-5! rounded-(--borderRadius)! border! border-(--borderColor)! box-border!">
               <div className="flex flex-col">
                  <span className="inline-flex mb-1! text-(--textColor) opacity-40 uppercase tracking-[1px]! font-bold! text-[0.6rem]!">
                     {props.type === 'cadastro' ? 'Valor' : 'Valor atual'}
                  </span>
                  <div className="inline-flex items-center gap-1">
                     <span className={`text-lg! font-semibold! ${price.id ? 'text-green-400' : 'italic'}`}>
                        R$ {formatMoney(price.amount)}
                     </span>
                     <span>por {BillingPeriodUnit[period].toLowerCase()}</span>
                     {!price.id && (
                        <span className="opacity-40">(Não salvo)</span>
                     )}
                  </div>
               </div>
               <div className="flex flex-col">
                  <span className="inline-flex mb-1! text-(--textColor) opacity-40 uppercase tracking-[1px]! font-bold! text-[0.6rem]!">
                     Inicio
                  </span>
                  <span className="h-[28px]! inline-flex items-center">
                     {capitalize(new Date(`${price.startDate}${!price.startDate.includes(':') ? 'T00:00:00' : ''}`).toLocaleDateString(LOCALES[i18n.language], {
                        timeZone: "America/Sao_Paulo",
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                     }))}
                     <span className='text-xs! opacity-60! ml-1!'>
                        (<TimeAgo date={new Date(`${price.startDate}${!price.startDate.includes(':') ? 'T00:00:00' : ''}`)} simple={true} showText={true} />)
                     </span>
                  </span>
               </div>
               <div>
                  {priceMonth.amount != null && priceMonth.amount > (price.amount / periodMonths) && (
                     <div className="flex flex-col">
                        <span className="inline-flex mb-1! text-(--textColor) opacity-40 uppercase tracking-[1px]! font-bold! text-[0.6rem]!">
                           Desconto
                        </span>
                        <span className="inline-flex font-bold! text-red-400 px-2! py-1.5! bg-red-400/10 rounded-full">
                           -{((1 - (price.amount / periodMonths) / priceMonth.amount) * 100).toFixed(1)}%
                        </span>
                     </div>
                  )}
               </div>
            </div>
         ) : (
            <p className="text-[0.9rem]! opacity-50!">
               Nenhum preço {BillingPeriodText[period].toLowerCase()}
            </p>
         )}
      </div>
   );
}
